import { useCallback, useEffect, useState } from 'react'

type ParamsType = {
	totalPage?: number
	currPage?: number
	displayNum: number
	onChangePage?: (page: number) => void
}

const usePagination = ({
	totalPage: initTotalPage = 1,
	currPage: initCurrPage = 1,
	displayNum,
	onChangePage,
}: ParamsType) => {
	const [currPage, setCurrPage] = useState(initCurrPage)
	const [totalPage, setTotalPage] = useState(initTotalPage)
	const [beginNum, setBeginNum] = useState<number | null>(null)
	const [endNum, setEndNum] = useState<number | null>(null)
	const prevNum = beginNum && beginNum > 1 ? beginNum - 1 : null
	const nextNum = endNum && totalPage && endNum < totalPage ? endNum + 1 : null
	useEffect(() => {
		setTotalPage(initTotalPage)
	}, [initTotalPage])
	useEffect(() => {
		setCurrPage(initCurrPage)
	}, [initCurrPage])

	useEffect(() => {
		if (displayNum % 2 === 0) {
			let newBeginNum = currPage - Math.floor((displayNum - 1) / 2)
			let newEndNum = currPage + Math.ceil((displayNum - 1) / 2)
			if (newBeginNum < 1) {
				newEndNum = 1 - newBeginNum + newEndNum
				newBeginNum = 1
				if (newEndNum > totalPage) {
					newEndNum = totalPage
				}
			}
			if (newEndNum > totalPage) {
				newBeginNum -= newEndNum - totalPage
			}

			newBeginNum = newBeginNum < 1 ? 1 : newBeginNum
			newEndNum = newEndNum > totalPage ? totalPage : newEndNum

			setBeginNum(newBeginNum)
			setEndNum(newEndNum)
		} else {
			let newBeginNum = currPage - (displayNum - 1) / 2
			let newEndNum = currPage + (displayNum - 1) / 2

			if (newBeginNum < 1) {
				newEndNum = 1 - newBeginNum + newEndNum
				newBeginNum = 1
				if (newEndNum > totalPage) {
					newEndNum = totalPage
				}
			}
			if (newEndNum > totalPage) {
				newBeginNum -= newEndNum - totalPage
			}

			newBeginNum = newBeginNum < 1 ? 1 : newBeginNum
			newEndNum = newEndNum > totalPage ? totalPage : newEndNum

			setBeginNum(newBeginNum)
			setEndNum(newEndNum)
		}
	}, [currPage, totalPage, displayNum])
	const selectPage = (i: number) => {
		setCurrPage(i)
		if (onChangePage) {
			onChangePage(i)
		}
	}
	return {
		beginNum,
		endNum,
		prevNum,
		nextNum,
		currPage,
		selectPage,
	}
}

export default usePagination
